import styled from 'styled-components'

const PaySuccess = styled.div`
  width: 100%;
`

const PaySuccessMain = styled.div`
  width: 1200px;

  margin: auto;

  position: relative;

  padding-top: 60px;
  padding-bottom: 58px;

  background-color: rgba(20, 21, 21, 0.8);
  > .leftTop {
    position: absolute;
    left: 0;
    top: 0;
  }

  > .rightTop {
    position: absolute;
    right: 0;
    top: 0;
  }

  > .notification {
    width: 736px;
    height: 13px;
    margin: auto;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(188, 150, 159, 1);
    line-height: 30px;
  }
`

const PaySuccessStatusBlock = styled.div`
  /* width: 450px; */
  height: 170px;

  margin: auto;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  > .orderInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    margin-left: 36px;
    > .title {
      margin-bottom: 34px;
      > .orderText {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }
      > span {
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        > strong {
          font-size: 16px;
          color: rgba(219, 57, 80, 1);
        }
      }
    }
    > .row {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      > .name {
        color: #a8a8a8;
      }
      > .value {
        color: #ffffff;
      }
      > .ope {
        text-decoration: underline;
        color: rgba(9, 232, 208, 1);

        margin-left: 10px;
      }
    }
  }
`

const PaySuccessGoodsInfo = styled.div`
  width: 880px;
  height: 200px;
  border: 1px dashed rgba(41, 72, 76, 1);

  margin: auto;
  margin-top: 15px;

  padding-left: 37px;
  padding-top: 25px;

  > .title {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    > img {
      width: 14px;
      height: 13px;
    }
    > span {
      font-size: 12px;
      color: rgba(255, 255, 255, 1);

      margin-left: 9px;
    }
  }

  > .body {
    padding-left: 13px;
    padding-top: 19px;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    color: #d2d2d2;

    > img {
      width: 84px;
      height: 84px;
    }

    > .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      color: #cacaca;

      width: 400px;
      word-break: break-all;

      margin-left: 21px;
      > .name {
        font-size: 12px;
        color: rgba(255, 255, 255, 1);
      }
      > .service {
        padding: 2px;
        color: rgba(250, 125, 96, 1);
        border: 1px solid rgba(250, 125, 96, 1);
      }
    }

    > .price {
      margin-left: 76px;
      color: rgba(219, 57, 80, 1);
    }
    > .num {
      margin-left: 72px;
    }
    > .stock {
      margin-left: 70px;
    }
    > .fee {
      margin-left: 72px;
    }
  }
`

const Button = styled.div`
  cursor: pointer;
  width: 372px;
  height: 48px;
  background: linear-gradient(
    90deg,
    rgba(19, 216, 218, 1),
    rgba(21, 238, 215, 1)
  );

  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(6, 12, 19, 1);
  line-height: 18px;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: auto;
  margin-top: 30px;
`

export {
    PaySuccess,
    PaySuccessMain,
    PaySuccessStatusBlock,
    PaySuccessGoodsInfo,
    Button,
}
